import {useEffect, useState} from 'react';
import {useSearchClient} from './use-search';
import {TemperatureDeLivraison} from 'api-types/ffconnect';

// Configuration société → marque d'accueil (possible d'en mettre plusieurs)
// limit : nombre maximum de résultats à récupérer pour la marque d'accueil
const MARQUE_ACCUEIL_PAR_SOCIETE: Record<
  string,
  {marque: string; limit: number}
> = {
  'FFR_R-381': {marque: 'Laiterie Gilbert', limit: 50},
};

export const usePromoMpSearch = ({
  temperature_de_livraison,
}: {
  temperature_de_livraison: TemperatureDeLivraison | undefined;
}) => {
  const search = useSearchClient();
  const [itemResultsPromo, setItemResultsPromo] =
    useState<Awaited<ReturnType<typeof search.searchItems>>>();
  const [itemResultsMP, setItemResultsMP] =
    useState<Awaited<ReturnType<typeof search.searchItems>>>();
  const [itemResultsMarque, setItemResultsMarque] =
    useState<Awaited<ReturnType<typeof search.searchItems>>>();
  const [isLoading, setIsLoading] = useState(true);

  //Si on n'a pas pu respecter le temperature de livraison de la tournée, on l'indique à l'utilisateur
  const [temperatureTourneeIgnoree, setTemperatureTourneeIgnoree] =
    useState(false);

  const temperature_livraison =
    temperature_de_livraison !== 'les_deux'
      ? temperature_de_livraison
      : undefined;

  // Récupérer la marque d'accueil selon la société du client
  const marqueAccueil = search.societeCommercialeId
    ? MARQUE_ACCUEIL_PAR_SOCIETE[search.societeCommercialeId]
    : undefined;

  useEffect(() => {
    if (search.indexIsBuilt) {
      setIsLoading(true);

      if (marqueAccueil) {
        // Société avec marque spécifique → chercher tous les produits de cette marque
        // On passe la limite configurée
        search
          .searchItems(
            {q: marqueAccueil.marque, temperature_livraison},
            marqueAccueil.limit,
          )
          .then((results) => {
            setItemResultsMarque(results);
          })
          .finally(() => {
            setIsLoading(false);
          });
      } else {
        // Comportement par défaut : promos + MP
        Promise.all([
          search.searchItems({nature_du_prix: 'promo'}),
          search.searchItems({est_MP: true, temperature_livraison}),
          search.searchItems({est_MP: true}),
        ])
          .then(([promoResults, mpResults, mpResultsAll]) => {
            setItemResultsPromo(promoResults);
            if (!temperature_livraison) setItemResultsMP(mpResults);
            else {
              if (mpResults.hits.length === 0) {
                setTemperatureTourneeIgnoree(true);
                setItemResultsMP(mpResultsAll);
              } else {
                setItemResultsMP(mpResults);
              }
            }
          })
          .finally(() => {
            setIsLoading(false);
          });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search.indexIsBuilt, marqueAccueil]);

  const promoDispo = itemResultsPromo?.hits && itemResultsPromo.hits.length > 0;

  const marqueAccueilDispo =
    itemResultsMarque?.hits && itemResultsMarque.hits.length > 0;

  return {
    itemResultsPromo,
    itemResultsMP,
    itemResultsMarque,
    marqueAccueil,
    marqueAccueilDispo,
    isLoading,
    promoDispo,
    temperatureTourneeIgnoree,
  };
};
